// @material-ui/icons
import LibraryBooks from '@material-ui/icons/LibraryBooks'
import BubbleChart from '@material-ui/icons/BubbleChart'
import LocationOn from '@material-ui/icons/LocationOn'

// Public views
import LoginView from 'Views/Public/LoginPage'
import StudentForgotPassword from 'Views/Public/StudentForgotPassword'
import ForgotView from 'Views/Public/ForgotPassword'
import NotFoundView from 'Views/Public/NotFound'
import TwoFactorCallbackPage from 'Views/Public/TwoFactorCallbackPage'

import StudentLoginPage from 'Views/Public/StudentLoginPage'
import StudentEmbed from 'Views/StudentPrivate/StudentEmbed'

const publicRoutes = [
    {
        path: '/login',
        name: 'Login',
        icon: LibraryBooks,
        component: LoginView,
    },
    {
        path: '/register',
        name: 'Register',
        icon: BubbleChart,
        component: LoginView,
    },
    {
        path: '/forgot',
        name: 'Forgot',
        icon: LibraryBooks,
        component: ForgotView,
    },
    {
        path: '/auth/2fa/callback',
        name: '2FA Callback',
        icon: LibraryBooks,
        component: TwoFactorCallbackPage,
    },
    {
        path: '/404',
        name: 'Icons',
        icon: LocationOn,
        component: NotFoundView,
    },
    {
        path: '/student/login',
        name: 'Student Login',
        icon: LibraryBooks,
        component: StudentLoginPage,
    },
    {
        path: '/student/register',
        name: 'Student Register',
        icon: BubbleChart,
        component: StudentLoginPage,
    },
    {
        path: '/student/forgot',
        name: 'Forgot',
        icon: LibraryBooks,
        component: StudentForgotPassword,
    },
    {
        path: '/student/404',
        name: 'Icons',
        icon: LocationOn,
        component: NotFoundView,
    },
    {
        path: '/student/embed',
        name: 'Embed',
        icon: LibraryBooks,
        component: StudentEmbed,
    },
]

export default publicRoutes
